import { render } from "./CategoriesAutoSelectionPanel.vue?vue&type=template&id=c4ab18ae&scoped=true"
import script from "./CategoriesAutoSelectionPanel.vue?vue&type=script&lang=js"
export * from "./CategoriesAutoSelectionPanel.vue?vue&type=script&lang=js"

import "./CategoriesAutoSelectionPanel.vue?vue&type=style&index=0&id=c4ab18ae&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ab18ae"]])

export default __exports__